class WelcomePopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName    = 'Minimog:welcome-popup';
    this.modal         = this.querySelector('.m-modal');
    this.closeBtn      = this.querySelector('[data-welcome-close]');
    this.skipBtn       = this.querySelector('[data-welcome-skip]');
    this.successCloseBtn = this.querySelector('[data-welcome-success-close]');
    this.formEl        = this.querySelector('form');
    this.submitBtn     = this.querySelector('[data-welcome-submit-btn]');
    this.submitLabel   = this.querySelector('[data-welcome-submit-label]');
    this.errorBox      = this.querySelector('[data-welcome-error]');
    this.errorMsg      = this.querySelector('[data-welcome-error-msg]');
    this.contentView   = this.querySelector('[data-welcome-content]');
    this.successView   = this.querySelector('[data-welcome-success]');
    this.isEnabled     = this.dataset.enable === 'true';
    this.isDesignMode  = this.dataset.designMode === 'true';
    this.delayMs       = parseInt(this.dataset.delay || '1200', 10);
    this._origLabel    = this.submitLabel ? this.submitLabel.textContent : '';
  }

  connectedCallback() {
    if (this.closeBtn)        this.closeBtn.addEventListener('click', () => this.dismiss());
    if (this.skipBtn)         this.skipBtn.addEventListener('click', () => this.dismiss());
    if (this.successCloseBtn) this.successCloseBtn.addEventListener('click', () => this.closePopup());

    if (this.formEl) {
      this.formEl.addEventListener('submit', (e) => {
        e.preventDefault();
        this._submitAjax();
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.dismiss();
      });
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', this._onSectionSelect.bind(this));
      document.addEventListener('shopify:section:load',   this._onSectionLoad.bind(this));
    }

    this._init();
  }

  disconnectedCallback() {
    if (Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:select', this._onSectionSelect.bind(this));
      document.removeEventListener('shopify:section:load',   this._onSectionLoad.bind(this));
    }
  }

  _init() {
    if (getCookie(this.cookieName)) return;
    if (!this.isEnabled && !this.isDesignMode) return;
    if (Shopify && Shopify.designMode && !this.isDesignMode) return;

    setTimeout(() => this.openPopup(), this.delayMs);
  }

  async _submitAjax() {
    if (!this.formEl) return;

    const emailInput = this.formEl.querySelector('[type="email"]');
    if (!emailInput || !emailInput.value.trim()) {
      this._showError();
      return;
    }

    this._setLoading(true);
    this._hideError();

    const formData = new FormData(this.formEl);

    try {
      const response = await fetch(window.location.pathname, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const html = await response.text();

      if (html.includes('notification show success') || html.includes('contact_posted=true')) {
        setCookie(this.cookieName, 'subscribed', 365);
        this._showSuccessView();
      } else if (html.includes('notification show warning') || html.includes('notification--error-message')) {
        const parser = new DOMParser();
        const doc    = parser.parseFromString(html, 'text/html');
        const msgEl  = doc.querySelector('.notification--error-message');
        this._showError(msgEl ? msgEl.textContent.trim() : null);
        this._setLoading(false);
      } else {
        // No explicit error found — treat as success to avoid blocking the user
        setCookie(this.cookieName, 'subscribed', 365);
        this._showSuccessView();
      }
    } catch (_err) {
      // Network error — show success anyway so the user is not blocked
      setCookie(this.cookieName, 'subscribed', 365);
      this._showSuccessView();
    }
  }

  _setLoading(on) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = on;
    if (this.submitLabel) {
      this.submitLabel.textContent = on ? '\u2026' : this._origLabel;
    }
  }

  _showError(msg) {
    if (!this.errorBox) return;
    if (msg && this.errorMsg) this.errorMsg.textContent = msg;
    this.errorBox.classList.remove('m:hidden');
  }

  _hideError() {
    if (this.errorBox) this.errorBox.classList.add('m:hidden');
  }

  _showSuccessView() {
    if (this.contentView) this.contentView.classList.add('m:hidden');
    if (this.successView) this.successView.classList.add('is-visible');
  }

  _onSectionLoad(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.isDesignMode) {
      this.openPopup();
    }
  }

  _onSectionSelect(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.isDesignMode) {
      this.openPopup();
    } else if (Shopify && Shopify.designMode) {
      this.closePopup();
    }
  }

  openPopup() {
    if (!this.modal) return;
    this.modal.style.setProperty('--m-opacity', '1');
    this.modal.classList.add('m-open-modal');
    document.documentElement.classList.add('prevent-scroll');
  }

  closePopup() {
    if (!this.modal) return;
    this.modal.classList.remove('m-open-modal');
    this.modal.style.setProperty('--m-opacity', '0');
    document.documentElement.classList.remove('prevent-scroll');
  }

  dismiss() {
    setCookie(this.cookieName, 'dismissed', 30);
    this.closePopup();
  }
}

customElements.define('m-welcome-popup', WelcomePopup);
